<template>
  <v-app>
    <v-container class="grey lighten-5 fill-height" fluid>
      <v-row>
        <v-col cols="24">
          <v-card class="mx-auto">
            <v-toolbar color="black" dark>
              <v-toolbar-title>{{
                $t("startup-screen.settings")
              }}</v-toolbar-title>
            </v-toolbar>
            <v-list two-line subheader>
              <v-subheader>{{ this.addconnection }}</v-subheader>

              <!-- <v-row v-show="amplify_loggedin" justify="space-around">
                <v-col align="center">
                  <span>Username: {{ this.username }}</span>
                </v-col>
                <v-col>
                  <amplify-sign-out v-show="amplify_loggedin"></amplify-sign-out
                ></v-col>
              </v-row>
              <v-checkbox
                class="ml-5"
                v-show="amplify_loggedin"
                v-model="useAmplify"
                @click="useAmplifySetting"
                label="Will you use cloud store for your settings?"
              ></v-checkbox>
              <v-row
                v-show="!amplify_loggedin"
                align="center"
                justify="space-around"
              >
                <v-col cols="24" align="center">
  
                    @click="signInAccountDialog = true"
                    x-large
                    block
                    color="primary"
                  >
                    {{ $t("startup-screen.createAccount") }}
                  </v-btn> 
                </v-col>
     
              </v-row> -->
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{ getSageCRMTitle() }}</v-list-item-title>
                  <v-list-item-subtitle
                    class="wrap-text"
                    v-html="getSageCRMTitleRequires()"
                  >
                  </v-list-item-subtitle>

                  <div class="my-2">
                    <v-btn
                      v-show="showAddNewConnection()"
                      color="black"
                      dark
                      large
                      @click="
                        newConnection(
                          'MyTaskPaneEntityDataSageCRMAcceleratorClass'
                        )
                      "
                    >
                      <v-icon dark>{{ plusMinusIcon }}</v-icon></v-btn
                    >
                  </div>

                  <!--       
          <v-list-item-subtitle v-show="!showAddNewConnection()">
               {{$t('startup-screen.maxconnections')}}</v-list-item-subtitle>
               -->
                </v-list-item-content>
              </v-list-item>

              <!--    
    TO DO...COMMENT BACK IN WHEN WE HAVE DEMO CONNECTOR FINISHED 
              <v-list-item>
                <v-list-item-content>
                  <v-list-item-title>{{
                    this.democonnection
                  }}</v-list-item-title>
                  <v-list-item-subtitle
                    class="wrap-text"
                    v-html="getDemoCRMTitleRequires()"
                  >
                  </v-list-item-subtitle>
                  <div class="my-2">
                    <v-btn
                      color="black"
                      dark
                      large
                      @click="
                        newDemoConnection('MyTaskPaneEntityDataDemoClass')
                      "
                    >
                      <v-icon dark>{{ plusMinusIcon }}</v-icon></v-btn
                    >
                  </div>
                </v-list-item-content>
              </v-list-item>
 -->
            </v-list>

            <v-divider></v-divider>
            <v-dialog
              v-model="addNewConnection"
              persistent
              class="new-connection-dialog"
              max-width="600px"
              scrollable
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card tscomp="tsnewconnection" class="editconnection">
                <v-card-title class="primary white--text">
                  <span>{{ $t("startup-screen.newconnection") }}</span>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    large
                    @click="
                      addNewConnection = false;
                      alert = false;
                    "
                    class="white--text"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                </v-card-title>
                <v-card-text>
                  <v-form>
                    <MyFormUrl
                      v-model="data_url"
                      @changedValue="changedDataUrl"
                    />
                    <p v-if="urlErrorFlag" class="errorUrl" style="color: red">
                      {{ $t("startup-screen.urlerrorMsg") }}
                    </p>
                    <MyFormUserName v-model="data_username" />

                    <MyFormPassword v-model="data_password" />
                    <v-alert
                      v-model="success"
                      :close-text="connectionSuccessAlert"
                      dark
                      type="success"
                    >
                      {{ $t("startup-screen.connectionsuccess") }}
                    </v-alert>

                    <v-alert
                      v-model="alert"
                      :close-text="connectionFailedAlert"
                      type="error"
                    >
                      <!-- {{ $t("startup-screen.connectionfailed") }} -->
                      {{ connectionFailedAlert }}
                    </v-alert>
                    <MyFormCheckbox v-model="data_rememberme" />
                    <MyFormInput v-model="data_connectionName" />
                    <v-alert
                      v-model="con_name_alert"
                      close-text="Change connection name, already existing now"
                      type="error"
                    >
                      {{ $t("startup-screen.connectionNameExisting") }}
                    </v-alert>
                    <MyFormInput v-model="data_connectionCaption" />
                    <v-alert
                      v-model="con_caption_alert"
                      close-text="Change connection caption, already existing now"
                      type="error"
                    >
                      {{ $t("startup-screen.connectionCaptionExisting") }}
                    </v-alert>
                    <MyFormCheckbox v-model="data_enabled" />
                    <MyFormNumber
                      v-if="this.tabs.length > 0"
                      v-model="data_order"
                    />
                  </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <v-btn
                    tile
                    large
                    outlined
                    class="ma-2"
                    color="second"
                    @click="resetForm()"
                  >
                    <v-icon>mdi-close</v-icon
                    >{{ $t("startup-screen.clear") }} </v-btn
                  ><v-spacer></v-spacer>
                  <v-btn
                    tile
                    large
                    outlined
                    class="ma-2"
                    color="second"
                    @click="submitForm()"
                    :loading="testOrSaveLoading"
                  >
                    <v-icon>mdi-check</v-icon>{{ this.testButtonCaption }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-dialog
              v-model="addNewDemoConnection"
              persistent
              class="new-connection-dialog"
              max-width="600px"
              scrollable
              hide-overlay
              transition="dialog-bottom-transition"
            >
              <v-card tscomp="tsnewconnection" class="addNewDemoConnection">
                <v-card-title class="primary white--text">
                  <span>{{ $t("startup-screen.newdemoconnection") }}</span>
                  <v-spacer></v-spacer>
                  <v-btn
                    icon
                    large
                    @click="addNewDemoConnection = false"
                    class="white--text"
                  >
                    <v-icon>mdi-close</v-icon>
                  </v-btn>
                  <p>{{ $t("startup-screen.demoCRMTitleRequires") }}</p>
                </v-card-title>
                <v-card-text>
                  <v-form>
                    <MyFormUserName v-model="data_username" :readonly="true" />
                    <MyFormPassword
                      v-model="data_password"
                      :readonly="true"
                      :filled="true"
                    />
                    <v-alert
                      v-model="success"
                      close-text="Connection Success"
                      dark
                      type="success"
                    >
                      {{ $t("startup-screen.connectionsuccess") }}
                    </v-alert>

                    <v-alert
                      v-model="alert"
                      close-text="Connection Failed"
                      type="error"
                    >
                      {{ $t("startup-screen.connectionfailed") }}
                    </v-alert>
                    <MyFormCheckbox v-model="data_rememberme" />
                    <MyFormInput v-model="data_connectionName" />
                    <v-alert
                      v-model="con_name_alert"
                      close-text="Change connection name, already existing now"
                      type="error"
                    >
                      {{ $t("startup-screen.connectionNameExisting") }}
                    </v-alert>
                    <MyFormInput v-model="data_connectionCaption" />
                    <v-alert
                      v-model="con_caption_alert"
                      close-text="Change connection caption, already existing now"
                      type="error"
                    >
                      {{ $t("startup-screen.connectionCaptionExisting") }}
                    </v-alert>
                    <MyFormCheckbox v-model="data_enabled" />
                    <MyFormNumber
                      v-if="this.tabs.length > 0"
                      v-model="data_order"
                    />
                  </v-form>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                  <!-- <v-btn
                    tile
                    large
                    outlined
                    class="ma-2"
                    color="black"
                    @click="resetForm()"
                  >
                    <v-icon>mdi-close</v-icon>{{ $t("startup-screen.clear") }}
                  </v-btn> -->
                  <v-spacer></v-spacer>
                  <v-btn
                    tile
                    large
                    outlined
                    class="ma-2"
                    color="second"
                    @click="submitDemoForm()"
                    :loading="testOrSaveLoading"
                  >
                    <v-icon>mdi-check</v-icon>{{ this.testButtonCaption }}
                  </v-btn>
                </v-card-actions>
              </v-card>
            </v-dialog>

            <v-divider></v-divider>

            <v-list v-show="this.tabs.length > 0" subheader two-line flat>
              <v-subheader>{{ this.existingconnections }}</v-subheader>

              <v-list-item v-for="tab in tabs" :key="tab.tabCaption">
                <v-list-item-action>
                  <div class="actionlist">
                    <v-btn color="black" dark small @click="editConnection(tab)"
                      ><v-icon dark>
                        mdi-pencil
                      </v-icon></v-btn
                    >
                    &nbsp;
                    <v-btn
                      color="error"
                      dark
                      small
                      @click="deleteConnection(tab)"
                      ><v-icon dark>
                        {{ getDeleteIcon(tab) }}
                      </v-icon></v-btn
                    >
                    <v-btn
                      dark
                      small
                      v-show="
                        confirmConnectionDelete &&
                          tab.tabName == tabToDelete.tabName
                      "
                      @click="deleteConnectionConfirm(tab)"
                    >
                      {{ $t("startup-screen.confirmdelete") }}</v-btn
                    >
                    <ThemeChanger :tab="tab" @connectionTab="connectionTab" />
                  </div>
                </v-list-item-action>
                <v-list-item-content>
                  <v-list-item-title>{{ tab.tabCaption }}</v-list-item-title>
                </v-list-item-content>
              </v-list-item>

              <v-dialog
                v-model="editConnectionFlag"
                persistent
                max-width="600px"
                scrollable
                hide-overlay
                transition="dialog-bottom-transition"
              >
                <v-card
                  tscomp="tseditconnection"
                  v-show="editConnectionFlag == true"
                  class="editconnection"
                >
                  <v-card-title class="primary white--text">
                    <span>{{ $t("startup-screen.editconnection") }}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      large
                      @click="editConnectionFlag = false"
                      class="white--text"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>

                  <v-card-text>
                    <v-form>
                      <MyFormUrl
                        v-model="data_url"
                        @changedValue="changedDataUrl"
                      />
                      <p
                        v-if="urlErrorFlag"
                        class="errorUrl"
                        style="color: red"
                      >
                        {{ $t("startup-screen.urlerrorMsg") }}
                      </p>
                      <MyFormUserName v-model="data_username" />
                      <MyFormPassword v-model="data_password" />
                      <MyFormCheckbox v-model="data_rememberme" />
                      <MyFormInput v-model="data_connectionName" />
                      <MyFormInput v-model="data_connectionCaption" />
                      <MyFormCheckbox v-model="data_enabled" />
                      <MyFormNumber v-model="data_order" />
                    </v-form>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                      tile
                      large
                      outlined
                      class="ma-2"
                      color="second"
                      @click="submitFormEdit()"
                    >
                      <v-icon>mdi-check</v-icon
                      >{{ $t("startup-screen.connect") }}
                    </v-btn>
                  </v-card-actions>
                </v-card>

                <v-alert
                  v-model="successEdit"
                  close-text="Connection Updated"
                  dark
                  type="success"
                >
                  {{ $t("startup-screen.connectionupdated") }}
                </v-alert>
              </v-dialog>

              <!-- sign in dialog -->
              <v-dialog
                v-model="signInAccountDialog"
                persistent
                class="create-account-dialog"
                max-width="600px"
                scrollable
                hide-overlay
                transition="dialog-bottom-transition"
              >
                <v-card tscomp="tscreateAccount" class="createAnAccount">
                  <v-card-title class="primary white--text">
                    <span>Sign In / Register</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      large
                      @click="signInAccountDialog = false"
                      class="white--text"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text class="amplify-authentication-wrapper">
                    <v-form class="mt-5">
                      <!-- <h3>
                        Sign in to your account
                      </h3> -->
                      <MyFormInput v-model="account_username" />
                      <MyFormInput v-model="account_userpassword" />
                      <div>
                        <p>
                          {{ $t("startup-screen.forgetyourpwd") }}
                          <a
                            @click="
                              signInAccountDialog = false;
                              resetPasswordDialog = true;
                            "
                            >{{ $t("startup-screen.resetPwd") }}</a
                          >
                        </p>
                      </div>
                      <v-row>
                        <v-col
                          ><p>
                            {{ $t("startup-screen.noaccount") }}
                            <a
                              @click="
                                signInAccountDialog = false;
                                createAccountDialog = true;
                              "
                              >{{ $t("startup-screen.createanaccount") }}</a
                            >
                          </p></v-col
                        >
                        <v-col
                          ><v-btn
                            @click="signInAccountDialog = false"
                            color="primary"
                            medium
                            block
                            >{{ $t("startup-screen.signin") }}</v-btn
                          ></v-col
                        >
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <!-- create an account dialog -->
              <v-dialog
                v-model="createAccountDialog"
                persistent
                class="create-account-dialog"
                max-width="600px"
                scrollable
                hide-overlay
                transition="dialog-bottom-transition"
              >
                <v-card tscomp="tscreateAccount" class="createAnAccount">
                  <v-card-title class="primary white--text">
                    <span>{{ $t("startup-screen.createanaccount") }}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      large
                      @click="createAccountDialog = false"
                      class="white--text"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-form class="mt-5">
                      <!-- <h3>
                        Sign in to your account
                      </h3> -->
                      <MyFormInput v-model="account_username" />
                      <MyFormInput v-model="account_useremail" />
                      <MyFormInput v-model="account_userpassword" />

                      <v-row>
                        <v-col></v-col>
                        <v-col
                          ><v-btn
                            @click="createAccountDialog = false"
                            color="primary"
                            medium
                            block
                            >{{ $t("startup-screen.createanaccount") }}</v-btn
                          ></v-col
                        >
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>

              <!-- Reset password dialog -->
              <v-dialog
                v-model="resetPasswordDialog"
                persistent
                class="reset-password-dialog"
                max-width="600px"
                scrollable
                hide-overlay
                transition="dialog-bottom-transition"
              >
                <v-card tscomp="tscreateAccount" class="resetPasswordDialog">
                  <v-card-title class="primary white--text">
                    <span>{{ $t("startup-screen.resetPwd") }}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      large
                      @click="resetPasswordDialog = false"
                      class="white--text"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <v-form class="mt-5">
                      <!-- <h3>
                        Sign in to your account
                      </h3> -->
                      <MyFormInput v-model="account_useremail" />

                      <v-row>
                        <v-col></v-col>
                        <v-col
                          ><v-btn
                            @click="resetPasswordDialog = false"
                            color="primary"
                            medium
                            block
                            >{{ $t("startup-screen.resetPwd") }}</v-btn
                          ></v-col
                        >
                      </v-row>
                    </v-form>
                  </v-card-text>
                </v-card>
              </v-dialog>
              <v-dialog
                v-model="resetDialog"
                persistent
                class="reset-dialog"
                max-width="400px"
                transition="dialog-bottom-transition"
              >
                <v-card tscomp="tsnewconnection" class="editconnection">
                  <v-card-title class="primary white--text">
                    <span>{{ $t("startup-screen.reset") }}</span>
                    <v-spacer></v-spacer>
                    <v-btn
                      icon
                      large
                      @click="resetDialog = false"
                      class="white--text"
                    >
                      <v-icon>mdi-close</v-icon>
                    </v-btn>
                  </v-card-title>
                  <v-card-text>
                    <p class="pt-5">
                      <v-icon>mdi-alert-outline</v-icon>
                      {{ $t("startup-screen.resetDialogText") }}
                    </p>
                  </v-card-text>
                  <v-divider></v-divider>
                  <v-card-actions>
                    <v-btn
                      tile
                      large
                      outlined
                      class="ma-2"
                      color="second"
                      @click="resetApp()"
                    >
                      <v-icon>mdi-check</v-icon>Yes</v-btn
                    ><v-spacer></v-spacer>
                    <v-btn
                      tile
                      large
                      outlined
                      class="ma-2"
                      color="second"
                      @click="resetDialog = false"
                    >
                      <v-icon>mdi-close</v-icon>No
                    </v-btn>
                  </v-card-actions>
                </v-card>
              </v-dialog>
            </v-list>
          </v-card>
        </v-col>
      </v-row>

      <v-row align="center" justify="space-around" v-if="showOpenAppButton()">
        <v-col cols="24" align="center">
          <v-btn
            v-show="this.tabs.length > 0"
            @click="backToApp()"
            x-large
            block
            color="primary"
          >
            {{ $t("startup-screen.openapplication") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row align="center" justify="space-around" v-else>
        <v-col cols="24" align="center">
          <v-btn
            v-show="this.tabs.length > 0"
            @click="closeClick()"
            x-large
            block
            color="primary"
          >
            {{ $t("common.close") }}
          </v-btn>
        </v-col>
      </v-row>

      <v-row align="center" justify="space-around">
        <v-col cols="24" align="left">
          <v-card>
            <v-card-text>
              {{ $t("startup-screen.selecttheme") }}
              <ThemeChanger />
              <div>{{ $t("startup-screen.fontsize") }}</div>
            </v-card-text>
            <v-card-actions>
              <v-slider
                v-model="fontsize"
                max="40"
                min="12"
                thumb-label="always"
                @change="fontsizeChange"
              ></v-slider>
            </v-card-actions>
            <v-card-text>
              <v-select
                :items="languages"
                v-model="curLanguage"
                item-text="key"
                :label="languageCaption"
                return-object
                v-on:change="onChangeLanguage"
                dense
              >
              </v-select
            ></v-card-text>

            <v-card-text>
              <v-text-field
                type="number"
                v-model="listColumnCount"
                :label="listColumnCountsCaption"
                @change="onChangeListColumnCount"
                min="3"
              ></v-text-field>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row
        align="center"
        justify="space-around"
        v-if="tabs.length > 0 && showOpenAppButton()"
      >
        <v-col cols="24" align="center">
          <v-btn @click="resetDialog = true" x-large block color="primary">
            {{ $t("startup-screen.reset") }}
          </v-btn>
        </v-col>
      </v-row>
      <v-row align="center" justify="space-around">
        <v-col cols="24" align="center">
          <v-card>
            <v-card-text>
              <p>{{ $t("startup-screen.version") }}: 1.0.1.4</p>
              <p>{{ siteUrl }}</p>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
      <v-row id="spacer1" align="center" justify="space-around">
        <v-col cols="24" align="center"> <br /><br /><br /> </v-col>
      </v-row>

      <v-footer padless app>
        <v-card flat tile width="100%" class="text-center">
          <v-card-text>
            <v-btn class="mx-2" text width="60px">
              <a
                elevation="0"
                @click="getCoreURL()"
                target="_blank"
                class="text-center"
              >
                <v-img
                  v-if="$vuetify.breakpoint.width > $extrasmall"
                  max-height="20"
                  max-width="80"
                  src="assets/logo_alt_wide.png"
                  style="text-align:center"
                  :class="{ brandedimagehover: hover }"
                >
                </v-img>
                <v-img
                  v-else
                  max-height="30"
                  max-width="30"
                  src="assets/icon-80.png"
                  style="text-align:center"
                  :class="{ brandedimagehover: hover }"
                >
                </v-img>
              </a>
            </v-btn>
          </v-card-text>
        </v-card>
      </v-footer>
    </v-container>
  </v-app>
</template>

<script>
// eslint-disable-next-line
import { applog } from "@/services/applog.js";
// import { onAuthUIStateChange } from "@aws-amplify/ui-components";

import { AppConnection } from "@/services/MyTaskPane/appConnections";
import DataFactoryClass from "@/services/dataFactory";

import MyFormUrl from "@/components/FormElements/MyFormURL";
import MyFormUserName from "@/components/FormElements/MyFormUserName";
import MyFormPassword from "@/components/FormElements/MyFormPassword";
import MyFormCheckbox from "@/components/FormElements/MyFormCheckbox";
import MyFormInput from "@/components/FormElements/MyFormInput";
import MyFormNumber from "@/components/FormElements/MyFormNumber";
import ThemeChanger from "@/components/ThemeChanger";
import ThemeFactoryClass from "@/services/themefactory";

import { Plugins } from "@capacitor/core";
// import i18n from "@/plugins/i18n";
const { Storage } = Plugins;
import { API, graphqlOperation } from "aws-amplify";
import * as mutations from "./../../graphql/mutations";
import * as queries from "./../../graphql/queries";
// import * as subscriptions from "./../../graphql/subscriptions";

//vue page object
export default {
  name: "startup",
  components: {
    MyFormUrl,
    MyFormUserName,
    MyFormPassword,
    MyFormCheckbox,
    MyFormInput,
    MyFormNumber,
    ThemeChanger,
  },
  async beforeCreate() {
    /** Amplify auth part- commented now */
    // try {
    //   const user = await Auth.currentAuthenticatedUser();
    //   console.log("this user:", user);
    //   this.amplify_loggedin = true;
    //   this.username = user.username;
    // } catch (error) {
    //   this.amplify_loggedin = false;
    //   this.username = "";
    // }
  },
  data() {
    return {
      urlErrorFlag: false,
      networkErrMsg: "",
      connectionSuccessAlert: this.$i18n.t("startup-screen.connectionsuccess"),
      connectionFailedAlert: this.$i18n.t("startup-screen.connectionfailed"),
      listColumnCount: 4,
      languages: [
        { key: "English UK", value: "en-GB" },
        { key: "English NA", value: "en-US" },
        { key: "German", value: "de" },
        { key: "France", value: "fr" },
        { key: "Spanish", value: "es" },
      ],

      curLanguage: { key: "English UK", value: "en-GB" },
      siteUrl: "",
      hover: false,
      fontsize: 18,
      testOrSaveLoading: false,
      localStorage: {
        connections: {
          type: Array,
          default: [],
        },
      },
      successEdit: false,
      languageCaption: this.$i18n.t("startup-screen.language"),
      listColumnCountsCaption: this.$i18n.t("startup-screen.ListColumnCounts"),
      testButtonCaption: this.$i18n.t("startup-screen.connect"),
      addconnection: this.$i18n.t("startup-screen.addconnection"),
      democonnection: this.$i18n.t("startup-screen.democonnection"),
      existingconnections: this.$i18n.t("startup-screen.existingconnections"),
      connectionClass: "",
      alert: false,
      signInAccountDialog: false,
      createAccountDialog: false,
      resetPasswordDialog: false,
      resetDialog: false,
      con_caption_alert: false,
      con_name_alert: false,
      success: false,
      confirmConnectionDelete: false,
      tabToDelete: null,
      tabToEdit: null,
      addNewConnection: false,
      addNewDemoConnection: false,
      editConnectionFlag: false,
      selectedTab: null,
      tabs: [],
      activeTabName: "",
      btnSubmitState: "",
      plusMinusIcon: "mdi-plus",
      editIcon: "mdi-pencil",
      deleteIcon: "mdi-delete",

      data_url: {
        name: "URL",
        caption:
          this.validateURL(window.location.href) == "https"
            ? this.$i18n.t("startup-screen.url") +
              "-(https://crm.yourserver.com/crm/)"
            : this.$i18n.t("startup-screen.url") +
              "-(http://crm.yourserver.com/crm/)",
        defaultValue:
          this.validateURL(window.location.href) == "https"
            ? "https://"
            : "http://",
        value: "",
        required: true,
        httpsRequired: false,
      },
      account_username: {
        name: "Username",
        caption: this.$i18n.t("startup-screen.username"),
        value: "",
      },
      account_useremail: {
        name: "Email",
        caption: this.$i18n.t("startup-screen.email"),
        value: "",
      },
      account_userpassword: {
        name: "Password",
        caption: this.$i18n.t("startup-screen.password"),
        value: "",
      },
      data_username: {
        name: "Username",
        caption: this.$i18n.t("startup-screen.username"),
        value: "",
      },
      data_password: {
        name: "Password",
        caption: this.$i18n.t("startup-screen.password"),
        value: "",
      },
      data_connectionName: {
        name: "ConnectionName",
        caption: this.$i18n.t("startup-screen.connectionname"),
        value: "",
        readonly: false,
        maxLength: 20,
      },
      data_connectionCaption: {
        name: "ConnectionCaption",
        caption: this.$i18n.t("startup-screen.connectioncaption"),
        value: "",
        maxLength: 20,
      },
      data_rememberme: {
        name: "RememberMe",
        caption: this.$i18n.t("startup-screen.rememberme"),
        value: true,
      },
      data_enabled: {
        name: "Enabled",
        caption: this.$i18n.t("startup-screen.enabled"),
        value: true,
      },
      demo_data_enabled: {
        name: "Enabled",
        caption: this.$i18n.t("startup-screen.enabled"),
        value: true,
      },
      data_order: {
        name: "Order",
        caption: this.$i18n.t("startup-screen.order"),
        value: 1,
      },
      data_connectiontype: { name: "Order", caption: "", value: "" },
      formFields: [
        {
          type: "username",
          label: "Username",
          placeholder: "User name",
          inputProps: { required: true, autocomplete: "username" },
        },
        {
          type: "email",
          label: "Email",
          placeholder: "Email",
          inputProps: { required: true, autocomplete: "useremail" },
        },
        {
          type: "password",
          label: "Password",
          placeholder: "Password",
          inputProps: { required: true, autocomplete: "new-password" },
        },
      ],
      user: {},
      username: "",
      authState: undefined,
      unsubscribeAuth: undefined,
      amplify_loggedin: false,
      useAmplify: false,
      curUserSetting: {},
      amplifyVersion: 0,
    };
  },
  async mounted() {
    // this.curLanguage = this.$i18n.locale || { key: "English UK", value: "en-GB" }

    /** Amplify auth part- commented now */
    // const user = await Auth.currentAuthenticatedUser();
    // await this.getCurUserSetting(user.username);
    // this.updateSubscription = API.graphql(
    //   graphqlOperation(subscriptions.onUpdateSetting)
    // ).subscribe({
    //   next: (settingData) => {
    //     console.log("settingData:", settingData);
    //     this.curUserSetting = settingData.value.data.onUpdateSetting;
    //   },
    // });
    // this.createSubscription = API.graphql(
    //   graphqlOperation(subscriptions.onCreateSetting)
    // ).subscribe({
    //   next: (settingData) => {
    //     console.log("settingData for create:", settingData);
    //   },
    // });

    // this.updateSubscription = API.graphql(
    //   graphqlOperation(subscriptions.onUpdateSetting)
    // ).subscribe({
    //   next: settingData => {
    //     const newData = this.curUserSetting.map(item =>
    //       item.id === todoData.value.data.onUpdateTodo.id
    //         ? { ...item, completed: !item.completed }
    //         : item
    //     );
    //     this.todos = newData;
    //   }
    // });
    this.useAmplifySetting();
  },
  watch: {
    "data_url.value": function(value) {
      if (value && value.includes("eware.dll")) {
        value = value.split("eware.dll", 1)[0];
        this.urlErrorFlag = true;

        window.setInterval(() => {
          this.urlErrorFlag = false;
        }, 5000);

        this.data_url.value = value;
      }
    },
    // "data_connectionCaption.value": function(newVal) {
    //   console.log("aaa", this.checkCaptionExising(newVal));
    // },
    // fontsize: async function(newVal) {
    //   // watch it
    //   document.documentElement.style.fontSize = newVal + "px";
    //   //store this....
    //   window.vueAppInstance.$localStorage.set("appfontSize", newVal);
    // },
    // curLanguage: function(newVal) {
    //   console.log("curLanguage:" + newVal.key + ", " + newVal.value);
    //   i18n.locale = newVal;
    //   Storage.set({ key: "appLanguageData", value: newVal.key });
    //   Storage.set({ key: "appLanguage", value: newVal.value }).then(() => {
    //     location.reload();
    //   });
    //   window.vueAppInstance.$localStorage.set("curLanguage", newVal);
    // },
  },
  methods: {
    connectionTab(tab) {
      this.tab = tab;
    },
    closeClick() {
      this.$applog("startup closeClick()");
      let _DataFactory = new DataFactoryClass();
      this.dataProvider = _DataFactory.getDataService("SageCRM");

      this.dataProvider.actioned("AttachDocuments", "close", "");
    },
    showOpenAppButton() {
      var _res = true;
      if (this.$route.params.container == "outlookaddin") {
        _res = false;
      }
      return _res;
    },
    validateURL(link) {
      if (link.indexOf("https://") == 0) {
        console.log("The link has https ");
        return "https";
      }
      if (link.indexOf("http://") == 0) {
        console.log("The link has http ");
        return "http";
      } else {
        console.log("The link doesn't have http or https.");
        return "";
      }
    },
    onChangeListColumnCount(val) {
      console.log("listColumnCount", val);
      if (val < 3) {
        this.listColumnCount = 3;
        val = 3;
      }
      window.vueAppInstance.$localStorage.set("listColumnCount", val);
    },
    setTheme(theme) {
      // close menu
      const name = theme.name;
      const dark = theme.dark;
      const light = theme.light;
      // set themes
      Object.keys(dark).forEach((i) => {
        this.$vuetify.theme.themes.dark[i] = dark[i];
      });
      Object.keys(light).forEach((i) => {
        this.$vuetify.theme.themes.light[i] = light[i];
      });
      // also save theme name to disable selection
      this.$vuetify.theme.themes.name = name;
      // window.vueAppInstance.$localStorage.set("apptheme", name);
    },
    async getCurUserSetting(username) {
      await API.graphql(
        graphqlOperation(queries.listSettings, {
          filter: {
            username: {
              eq: username,
            },
          },
        })
      ).then((res) => {
        console.log("current user setting: ", res.data.listSettings);
        this.curUserSetting = res.data.listSettings.items[0];
        this.amplifyVersion = this.curUserSetting._version;
      });
    },
    async createSetting() {
      const defaultSetting = {
        username: this.user.username,
        theme: "Red",
        language: "English US",
        fontSize: 19,
      };
      console.log("graphql started");
      await API.graphql(
        graphqlOperation(mutations.createSetting, { input: defaultSetting })
      )
        .then((res) => {
          console.log("added successfully", res);
        })
        .catch((err) => {
          // this.error = err.messag;
          console.log("adding failed", err.message);
        });
    },

    async fontsizeChange(val) {
      // store to amplify
      document.documentElement.style.fontSize = val + "px";
      if (this.useAmplify) {
        const settingDetails = {
          id: this.curUserSetting.id,
          fontSize: val,
          _version: this.curUserSetting._version,
        };
        console.log("settingDetails", settingDetails);
        await API.graphql(
          graphqlOperation(mutations.updateSetting, {
            input: settingDetails,
          })
        ).then((res) => {
          console.log("fontszie updated successfully", res);
        });
      } else {
        //store this....
        window.vueAppInstance.$localStorage.set("appfontSize", val);
      }
    },
    async setThemeName(themeName) {
      if (this.useAmplify) {
        const settingDetails = {
          id: this.curUserSetting.id,
          theme: themeName,
          _version: this.curUserSetting._version,
        };
        console.log("settingDetails", settingDetails);
        await API.graphql(
          graphqlOperation(mutations.updateSetting, {
            input: settingDetails,
          })
        ).then((res) => {
          console.log("updated successfully", res);
        });
      }
    },
    useAmplifySetting() {
      window.vueAppInstance.$localStorage.set("useAmplify", this.useAmplify);
      if (this.useAmplify) {
        //set fontsize
        this.fontsize = this.curUserSetting.fontSize;
        document.documentElement.style.fontSize = this.fontsize + "px";

        //set theme
        this.$vuetify.theme.themes.name = this.curUserSetting.theme;
        let themes = new ThemeFactoryClass().themes;
        //get the theme
        for (var ii = 0; ii < themes.length; ii++) {
          let themeObj = themes[ii];
          if (themeObj.name == this.$vuetify.theme.themes.name) {
            this.setTheme(themeObj);
          }
        }

        //set language
        const val = this.languages.filter((obj) => {
          return obj.key == this.curUserSetting.language;
        });

        this.curLanguage = {
          key: this.curUserSetting.language,
          value: val[0].value,
        };
        console.log("current language", this.curLanguage);
        this.$i18n.locale = this.curLanguage.value;
        // location.reload();
      } else {
        if (window.vueAppInstance.$localStorage.get("appfontSize") != null)
          this.fontsize = window.vueAppInstance.$localStorage.get(
            "appfontSize"
          );
        document.documentElement.style.fontSize = this.fontsize + "px";

        if (window.vueAppInstance.$localStorage.get("apptheme") != null) {
          this.$vuetify.theme.themes.name = window.vueAppInstance.$localStorage.get(
            "apptheme"
          );
          this.$applog("startup theme set:" + this.$vuetify.theme.themes.name);
          let themes = new ThemeFactoryClass().themes;
          //get the theme
          for (var jj = 0; jj < themes.length; jj++) {
            let themeObj = themes[jj];
            if (themeObj.name == this.$vuetify.theme.themes.name) {
              this.setTheme(themeObj);
            }
          }
        }

        Storage.get({ key: "appLanguageData" }).then((data) => {
          if (data.value == null) {
            this.curLanguage = { key: "English UK", value: "en-GB" };
          } else {
            Storage.get({ key: "appLanguage" }).then((data1) => {
              this.curLanguage = {
                key: data.value,
                value: data1.value,
              };
              this.$i18n.locale = this.curLanguage.value;
            });
          }

          //TO TEST LANGUAGES....
          // i18n.locale = 'en';
        });
      }
    },
    getCoreURL() {
      let __url =
        "https://crmtogether.com?utm_source=accelerator&utm_medium=inapp&utm_campaign=inapplink";
      try {
        this.$appContainer.OpenExternalURL(__url);
        return;
      } catch (e) {
        this.$applog("Navbar - getCoreURL ERROR:" + e.message);
      }
    },
    async onChangeLanguage() {
      var newVal = this.curLanguage;
      if (this.useAmplify) {
        console.log("amplifyversion:", this);
        // this.amplifyVersion += 1;
        const settingDetails = {
          id: this.curUserSetting.id,
          theme: this.curUserSetting.theme,
          username: this.curUserSetting.username,
          language: newVal.key,
          fontSize: this.curUserSetting.fontSize,
          _version: this.curUserSetting._version,
        };
        console.log("settingDetails", settingDetails);
        const updatedSetting = await API.graphql(
          graphqlOperation(mutations.updateSetting, {
            input: settingDetails,
          })
        ).then((res) => {
          console.log("updated successfully", res);
        });
        this.$i18n.locale = newVal.value;
        console.log("updatedSetting", updatedSetting);
      } else {
        Storage.set({ key: "appLanguageData", value: newVal.key });
        Storage.set({ key: "appLanguage", value: newVal.value }).then(() => {
          // location.reload();
          this.$i18n.locale = newVal.value;
        });
      }
    },
    changedDataUrl(val) {
      console.log("changedDataURL", val);
      this.data_url.value = val;
    },
    getSageCRMTitle() {
      if (this.$store.getters.appMode == "MX") {
        return this.$i18n.t("startup-screen.SageCRMTitleMX");
      } else {
        return this.$i18n.t("startup-screen.SageCRMTitle");
      }
    },
    getSageCRMTitleRequires() {
      if (this.$store.getters.appMode == "MX") {
        return this.$i18n.t("startup-screen.SageCRMTitleRequiresMX");
      } else {
        return this.$i18n.t("startup-screen.SageCRMTitleRequires");
      }
    },
    getDemoCRMTitleRequires() {
      if (this.$store.getters.appMode == "MX") {
        return this.$i18n.t("startup-screen.demoCRMTitleRequires");
      } else {
        return this.$i18n.t("startup-screen.demoCRMTitleRequires");
      }
    },
    showAddNewConnection() {
      let _connectioncounts = 1;
      if (this.$route.params.connectioncounts) {
        _connectioncounts = this.$route.params.connectioncounts;
      }
      if (this.tabs.length > _connectioncounts - 1) {
        this.addconnection = "";
        this.existingconnections = this.$i18n.t(
          "startup-screen.existingconnection"
        );
        return false;
      }
      return true;
    },
    getEditIcon(tab) {
      if (this.tabToEdit != null && tab.tabName == this.tabToEdit.tabName)
        return "mdi-minus";
      else return "mdi-pencil";
    },
    getDeleteIcon(tab) {
      if (this.tabToDelete != null && tab.tabName == this.tabToDelete.tabName)
        return "mdi-minus";
      else return "mdi-delete";
    },
    openSite() {
      let __url =
        "https://crmtogether.com?utm_source=accelerator&utm_medium=inapp&utm_campaign=inapplink";
      this.$appContainer.OpenExternalURL(__url);
    },
    editConnection(_tab) {
      console.log("_tab_editconnection", _tab);
      this.$applog("startup editConnection:");
      this.editConnectionFlag = !this.editConnectionFlag;
      if (this.editConnectionFlag) {
        this.editIcon = "mdi-minus";
        this.tabToEdit = _tab;
      } else {
        this.editIcon = "mdi-pencil";
        this.tabToEdit = null;
      }
      this.connectionClass = _tab.connectionClass;
      this.tabToDelete = null;
      if (
        _tab.connectionClass == "MyTaskPaneEntityDataSageCRMAcceleratorClass"
      ) {
        this.data_url.value = _tab.dataurl;
      } else {
        this.data_url.value = "";
      }
      this.data_url.value = _tab.dataurl;
      this.data_username.value = _tab.username;
      if (_tab.userFlag) {
        this.data_password.value = this.$aes.decrypt(_tab.password);
      } else this.data_password.value = _tab.password;
      this.data_rememberme.value = _tab.rememberMe;
      this.data_connectionName.value = _tab.tabName;
      this.data_connectionName.readonly = true;
      this.data_connectionCaption.value = _tab.tabCaption;
      this.data_enabled.value = _tab.enabled;
      this.data_order.value = _tab.order;
    },
    deleteConnection(_tab) {
      this.confirmConnectionDelete = !this.confirmConnectionDelete;
      this.editConnectionFlag = false;
      this.tabToDelete = _tab;
      this.tabToEdit = null;
      if (this.confirmConnectionDelete) {
        this.deleteIcon = "mdi-minus";
      } else {
        this.deleteIcon = "mdi-delete";
        this.tabToDelete = null;
      }
    },
    deleteConnectionConfirm(_tab) {
      for (var x = 0; x < this.tabs.length; x++) {
        if (this.tabs[x].tabName == _tab.tabName) {
          this.tabs.splice(x, 1);
          break;
        }
      }
      Storage.set({ key: "connections", value: JSON.stringify(this.tabs) });
      Storage.remove({ key: _tab.tabName + "_authobject" });
    },
    backToApp() {
      if (this.$store.getters.appMode == "MX") {
        this.$router.push({ name: "mytaskpanemx" });
      } else {
        this.$router.push({ name: "mytaskpane" });
      }
    },
    resetApp() {
      // window.vueAppInstance.$localStorage.clear();
      localStorage.clear();
      Storage.get({ key: "appLanguageData" }).then((data) => {
        if (data.value == null) {
          this.curLanguage = { key: "English UK", value: "en-GB" };
        } else {
          Storage.get({ key: "appLanguage" }).then((data1) => {
            this.curLanguage = {
              key: data.value,
              value: data1.value,
            };
          });
        }
        // i18n.locale = 'en';
      });
      location.reload();
    },
    newConnection(connectorType) {
      this.addNewConnection = !this.addNewConnection;
      //later on we check for other connections
      this.data_username.value = "";
      this.data_password.value = "";
      this.data_connectionName.value = "";
      this.data_connectionCaption.value = "";
      this.data_rememberme.value = true;
      this.data_enabled.value = true;
      this.data_order.value = this.tabs.length + 1;

      this.data_connectionName.value =
        this.tabs.length == 0 ? "SageCRM" : "SageCRM" + this.tabs.length;
      this.data_connectionCaption.value =
        this.tabs.length == 0 ? "Sage CRM" : "Sage CRM" + this.tabs.length;
      this.data_connectiontype.value = connectorType;
      this.data_connectionName.readonly = false;
      this.editConnectionFlag = false;
    },
    newDemoConnection(connectorType) {
      this.addNewDemoConnection = !this.addNewDemoConnection;
      //later on we check for other connections

      this.data_username.value = "admin";
      this.data_password.value = "";
      this.data_connectionName.value = "";
      this.data_connectionCaption.value = "";
      this.data_rememberme.value = true;
      this.data_enabled.value = true;
      this.data_order.value = this.tabs.length + 1;

      this.data_connectionName.value = "Demo";
      this.data_connectionCaption.value = "Demo";
      this.data_connectiontype.value = connectorType;
      this.data_connectionName.readonly = false;
      this.editConnectionFlag = false;
    },
    async submitFormEdit() {
      this.$applog("startup submitFormEdit");

      let _DataFactory = new DataFactoryClass();
      this.dataProvider = _DataFactory.getDataService("SageCRM");
      //save mode
      let connection = new AppConnection();
      connection.tabName = this.data_connectionName.value;
      connection.tabCaption = this.data_connectionCaption.value;
      connection.tabClass = "sagecrm";
      connection.tabAction = "summary";
      connection.enabled = this.data_enabled.value;
      connection.username = this.data_username.value;
      connection.password = this.$aes.encrypt(this.data_password.value);
      connection.rememberMe = this.data_rememberme.value;
      connection.provider = "SystemContainer";
      connection.connectionClass = this.connectionClass;
      connection.dataurl = this.data_url.value;
      connection.order = this.data_order.value;
      connection.userFlag = "new";
      this.btnSubmitState = "";
      //delete the tab
      this.deleteConnectionConfirm(this.tabToEdit);

      this.tabs.push(connection);
      Storage.set({ key: "connections", value: JSON.stringify(this.tabs) });

      this.resetForm();
      this.addNewConnection = false;
      this.editConnectionFlag = false;
      this.editIcon = "mdi-pencil";
      this.tabToEdit = null;
    },
    async submitForm() {
      this.$applog("startup submitForm");
      if (
        this.checkNameExising(this.data_connectionName.value) ||
        this.checkCaptionExising(this.data_connectionCaption.value)
      ) {
        if (this.checkNameExising(this.data_connectionName.value)) {
          this.con_name_alert = true;
          setTimeout(() => (this.con_name_alert = false), 3000);
        }
        if (this.checkCaptionExising(this.data_connectionCaption.value)) {
          this.con_caption_alert = true;
          setTimeout(() => (this.con_caption_alert = false), 3000);
        }
        return;
      }

      this.testOrSaveLoading = true;
      let _DataFactory = new DataFactoryClass();
      this.dataProvider = _DataFactory.getDataService("SageCRM");

      let form = {
        url: this.data_url.value,
        username: this.data_username.value,
        password: this.data_password.value,
        name: this.data_connectionName.value,
        connectiontype: this.data_connectiontype.value,
        caption: this.data_connectionCaption.value,
        rememberme: this.data_rememberme.value,
        enabled: this.data_enabled.value,
        order: this.data_order.value,
        appName: "Accelerator",
      };

      if (this.btnSubmitState == "") {
        this.dataProvider
          .validateConnection(form)
          .then((response) => {
            console.log("login response", response);

            let _loggedin = false;
            if (
              response.loggedinErr &&
              response.loggedinErr.message == "Network Error"
            ) {
              this.networkErrMsg =
                this.$i18n.t("startup-screen.networkErrorWithURL") +
                ` '` +
                form.url +
                ".' " +
                this.$i18n.t("startup-screen.ref77342");
              this.connectionFailedAlert = this.networkErrMsg;
              console.log("error...", this.networkErrMsg);
            }
            if (response) {
              _loggedin = response.loggedin;
            }
            if (_loggedin) {
              //store object...used in other screensv
              this.testButtonCaption = "Save";
              this.alert = false;
              this.success = true;
              this.btnSubmitState = "save";

              //save mode
              let connection = new AppConnection();
              connection.tabName = this.data_connectionName.value;
              connection.tabCaption = this.data_connectionCaption.value;
              connection.tabClass = "sagecrm";
              connection.tabAction = "summary";
              connection.enabled = this.data_enabled.value;
              connection.username = this.data_username.value;

              connection.password = this.$aes.encrypt(this.data_password.value);
              connection.rememberMe = this.data_rememberme.value;
              connection.provider = "SystemContainer";
              connection.connectionClass = this.connectionClass;
              connection.dataurl = this.data_url.value;
              connection.userFlag = "new";
              this.btnSubmitState = "";
              //save to localstorage
              this.tabs.push(connection);

              Storage.set({
                key: "connections",
                value: JSON.stringify(this.tabs),
              });

              //mx item..put back later?--this line actually messed up our connections in AC
              //this.$store.commit('add_connection', connection);

              this.resetForm();
              this.addNewConnection = false;
              this.testOrSaveLoading = false;
            } else {
              this.alert = true;
              this.success = false;
            }
            this.testOrSaveLoading = false;
          })
          .catch((e) => {
            console.log("error message", e);
            this.alert = true;
            this.success = false;
            this.testOrSaveLoading = false;
            console.error(e);
          });
      } else {
        console.log("save mode");
      }
    },
    submitDemoForm() {
      this.$applog("startup submitDemoForm");
      if (
        this.checkNameExising(this.data_connectionName.value) ||
        this.checkCaptionExising(this.data_connectionCaption.value)
      ) {
        if (this.checkNameExising(this.data_connectionName.value)) {
          this.con_name_alert = true;
          setTimeout(() => (this.con_name_alert = false), 3000);
        }
        if (this.checkCaptionExising(this.data_connectionCaption.value)) {
          this.con_caption_alert = true;
          setTimeout(() => (this.con_caption_alert = false), 3000);
        }
        return;
      }
      this.testOrSaveLoading = true;
      let _DataFactory = new DataFactoryClass();
      let demoConnection = {
        connectionClass: "MyTaskPaneEntityDataDemoClass",
      };

      this.dataProvider = _DataFactory.getDataService(demoConnection);

      let form = {
        url: "",
        username: this.data_username.value,
        password: this.data_password.value,
        name: this.data_connectionName.value,
        connectiontype: this.data_connectiontype.value,
        caption: this.data_connectionCaption.value,
        rememberme: this.data_rememberme.value,
        enabled: this.data_enabled.value,
        order: this.data_order.value,
        appName: "Accelerator",
      };

      if (this.btnSubmitState == "") {
        this.dataProvider
          .validateConnection(form)
          .then((response) => {
            let _loggedin = false;
            if (response) {
              _loggedin = response.loggedin;
            }
            if (_loggedin) {
              //store object...used in other screensv
              this.testButtonCaption = "Save";
              this.alert = false;
              this.success = true;
              this.btnSubmitState = "save";

              //save mode
              let connection = new AppConnection();
              connection.tabName = this.data_connectionName.value;
              connection.tabCaption = this.data_connectionCaption.value;
              connection.tabClass = "sagecrm";
              connection.tabAction = "summary";
              connection.enabled = this.data_enabled.value;
              connection.username = this.data_username.value;
              connection.password = this.$aes.encrypt(this.data_password.value);
              connection.rememberMe = this.data_rememberme.value;
              connection.provider = "SystemContainer";
              connection.connectionClass = "MyTaskPaneEntityDataDemoClass";
              connection.dataurl = this.data_url.value;
              this.btnSubmitState = "";
              //save to localstorage
              this.tabs.push(connection);

              Storage.set({
                key: "connections",
                value: JSON.stringify(this.tabs),
              });

              //mx item..put back later?--this line actually messed up our connections in AC
              //this.$store.commit('add_connection', connection);

              this.resetForm();
              this.addNewDemoConnection = false;
              this.testOrSaveLoading = false;
            } else {
              this.alert = true;
              this.success = false;
            }
            this.testOrSaveLoading = false;
          })
          .catch((e) => {
            this.alert = true;
            this.success = false;
            this.testOrSaveLoading = false;
            console.error(e);
          });
      } else {
        console.log("save mode");
      }
    },
    resetAlerts() {
      this.alert = false;
      this.success = false;
      this.testButtonCaption = this.$i18n.t("startup-screen.connect");
      this.confirmConnectionDelete = false;
      this.testOrSaveLoading = false;
    },
    resetForm() {
      this.$applog("startup resetForm");
      this.data_url.value = "https://";
      this.data_username.value = "";
      this.data_password.value = "";
      this.data_connectionName.value = "SageCRM";
      this.data_connectionCaption.value = "SageCRM";
      this.data_rememberme.value = true;
      this.testButtonCaption = this.$i18n.t("startup-screen.connect");
      this.plusMinusIcon = "mdi-plus";
      this.confirmConnectionDelete = false;
      this.data_connectionName.readonly = false;
      this.resetAlerts();
    },
    checkCaptionExising(newcaptionName) {
      var flag = false;
      this.tabs.forEach((tab) => {
        if (tab.tabCaption == newcaptionName) {
          flag = true;
          return;
        }
      });
      return flag;
    },
    checkNameExising(newconnName) {
      var flag = false;
      this.tabs.forEach((tab) => {
        if (tab.tabName == newconnName) {
          flag = true;
          return;
        }
      });
      return flag;
    },
  },
  async created() {
    /** Amplify auth part- commented now */

    // this.unsubscribeAuth = onAuthUIStateChange(async (authState, authData) => {
    //   console.log("authState, authData", authState, authData);
    //   this.authState = authState;
    //   this.user = authData;

    //   switch (authState) {
    //     case "signin":
    //       break;
    //     case "signedin":
    //       console.log("signedIn:");
    //       this.username = authData.username;
    //       this.amplify_loggedin = true;
    //       this.signInAccountDialog = false;
    //       await this.getCurUserSetting(this.username);
    //       // if (this.useAmplify) {
    //       // }
    //       break;
    //     case "confirmSignUp":
    //       this.createSetting();
    //       break;
    //     case "signedout":
    //       this.amplify_loggedin = false;
    //       this.username = "";
    //   }
    // });
    this.$on("changedValue", function(val) {
      console.log("Changed Value", val);
    });

    if (window.vueAppInstance.$localStorage.get("useAmplify") != null)
      this.useAmplify = JSON.parse(
        window.vueAppInstance.$localStorage.get("useAmplify")
      );
    console.log("this.useAmplify", this.useAmplify);

    if (window.vueAppInstance.$localStorage.get("appfontSize") != null)
      this.fontsize = window.vueAppInstance.$localStorage.get("appfontSize");
    if (this.useAmplify) this.fontsize = this.curUserSetting.fontSize;
    document.documentElement.style.fontSize = this.fontsize + "px";

    if (window.vueAppInstance.$localStorage.get("apptheme") != null) {
      this.$vuetify.theme.themes.name = window.vueAppInstance.$localStorage.get(
        "apptheme"
      );
      this.$applog("startup theme set:" + this.$vuetify.theme.themes.name);
      let themes = new ThemeFactoryClass().themes;
      //get the theme
      for (var ii = 0; ii < themes.length; ii++) {
        let themeObj = themes[ii];
        if (themeObj.name == this.$vuetify.theme.themes.name) {
          this.setTheme(themeObj);
        }
      }
      if (window.vueAppInstance.$localStorage.get("darkmode") != null) {
        this.$vuetify.theme.dark = JSON.parse(
          window.vueAppInstance.$localStorage.get("darkmode")
        );
      }
    }

    if (window.vueAppInstance.$localStorage.get("listColumnCount") != null) {
      this.listColumnCount = parseInt(
        window.vueAppInstance.$localStorage.get("listColumnCount")
      );
    }

    Storage.get({ key: "connections" }).then((connections) => {
      this.tabs =
        connections.value != null ? JSON.parse(connections.value) : [];
    });

    this.siteUrl = window.location.href;
  },
  beforeUnmount() {
    this.unsubscribeAuth();
  },
};
</script>

<style scoped>
.amplify-authentication-wrapper {
  display: flex;
  justify-content: center;
  /* margin: auto; */
  align-items: center;
  flex-direction: column;
  max-height: 493px;
  overflow: hidden !important;
}
html {
  /* overflow-y: scroll !important; */
}
.auth-container {
  min-height: fit-content !important;
  display: table-cell !important;
}
.v-application--wrap {
  height: 100vh !important;
}
.new-connection-dialog {
  max-height: 90%;
}
.actionlist {
  padding: 10px;
}
.poweredby {
  font-size: 0.6em !important;
}
.editconnection {
  overflow-y: scroll !important;
}
.wrap-text {
  white-space: unset;
}
</style>
